import { makeStyles } from '@material-ui/core/styles';
import { themeCommon } from '../../../styles/theme';


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        width: '550px',
        height: 'auto',
        [theme.breakpoints.down('md')]: {
            width: '250px',
        },
    },
    food_root: {
        display: 'flex',
        height: 'auto',
        width: 'auto',
    },
    gray: {
        backgroundColor: '#f5f5f5',
    },
    red: {
        backgroundColor: '#ff5768',
    },
    dark_red: {
        backgroundColor: '#da291c',
    },
    orange: {
        backgroundColor: '#FFBF00',
    },
    dark_orange: {
        backgroundColor: '#FF6A2B',
    },
    green: {
        backgroundColor: '#4DD091',
    },
    dark_green: {
        backgroundColor: '#46AA42',
    },
    avatar: {
        width: '50px',
        height: '50px',
    },
    progressbar_container: {
        display: 'flex',
        flexDirection: 'column',
        width: '500px',
        marginTop: '-10px',
        [theme.breakpoints.down('md')]: {
            width: '200px',
        },
    },
    progressbar: {
        position: 'relative',
        marginLeft: '-2px',
        maxWidth: '500px',
        width: '100%',
        height: '20px',
        overflow: 'hidden',
        borderRadius: '0px 10px 10px 0px',
        [theme.breakpoints.down('md')]: {
            maxWidth: '200px',
        },
    },
    borderColor_red: {
        border: "2px solid #ff5768"
    },
    borderColor_orange: {
        border: "2px solid #FFBF00"
    },
    borderColor_darkorange: {
        border: "2px solid #FF6A2B"
    },
    progress: {
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        transition: 'all .3s',
    },
    moodText: {
        position: 'relative',
        color: '#f5f5f5',
        marginLeft: '5px',
        fontSize: themeCommon.fontSize22px,
    },
    feedCountText: {
        position: 'relative',
        color: '#f5f5f5',
        marginLeft: '5px',
        marginTop: '12px',
        fontSize: themeCommon.fontSize22px,
    },
    feedCount: {
        position: 'absolute',
        left: '250px',
        top: 0,
        bottom: 0,
        color: '#364051',
        [theme.breakpoints.down('md')]: {
            left: '100px',
        },
    }
}), {
    name: 'MoodMeterHeadContainer',
    index: 1,
})

export default useStyles;